import React from 'react';

import style from './style.module.scss';

const FileImagePreview = ({ preview, title }) => {
  return <img src={preview} className={style.previewImage} alt={title} />;
};

export default FileImagePreview;
